<template>
  <v-card>
    <v-card-title>
      <span>Escolha os clientes que gostaria de enviar as notificações:</span>
    </v-card-title>
    <v-card-text>
      <form-group>
        <v-flex
          xs12
          md12
          lg12
        >
          <v-layout row>
            <only-search-filter />
            <v-spacer />
            <div class="mr-2">
              <v-layout>
                <v-flex>
                  <input-select
                    id="input:option"
                    v-model="option"
                    label="Enviar para"
                    :items="options"
                    item-text="text"
                    item-value="value"
                    :return-object="false"
                    :rules="[requiredRule]"
                    clearable
                    required
                  />
                </v-flex>
              </v-layout>
            </div>
            <communication-customer-filter />
          </v-layout>
          <v-layout row>
            <div v-show="isList">
              <v-layout>
                <v-flex>
                  <communication-client-list
                    v-model="selectedCustomers"
                    :select="isOption('selected')"
                  />
                </v-flex>
                <v-flex v-show="isOption('selected')">
                  <communication-selected-customers-list v-model="selectedCustomers" />
                </v-flex>
              </v-layout>
            </div>
            <span v-show="isOption('all')">Todos os clientes irão receber as notificações</span>
            <input-text-area
              v-if="isOption('list')"
              v-model="listIds"
              :rules="[onlyNumbersCommaSpace(), requiredRule]"
              label="Informe aqui um ou mais id(s) de clientes, separados por vírgulas"
              :rows="5"
              required
            />
          </v-layout>
          <v-layout
            v-if="isOption('elegivel')"
            align-start
            justify-start
          >
            <v-flex
              xs12
              md12
              lg12
            >
              <input-radio
                v-model="elegivelOption"
                label="Elegíveis:"
                :options="store.elegivelOptions"
                row
              />
            </v-flex>
          </v-layout>
        </v-flex>
      </form-group>
    </v-card-text>
    <slot />
  </v-card>
</template>

<script>
import FormGroup from 'Support/layout/FormGroup.vue';
import OnlySearchFilter from 'Support/components/crud/OnlySearchFilter.vue';
import InputSelect from 'Support/components/inputs/InputSelect.vue';
import rulesMixin from 'Support/mixins/rules-mixin';
import InputTextArea from 'Support/components/inputs/InputTextArea.vue';
import InputRadio from 'Support/components/inputs/InputRadio.vue';
import CommunicationCustomerFilter from './CommunicationCustomerFilter.vue';
import CommunicationClientList from './CommunicationClientList.vue';
import CommunicationSelectedCustomersList from './CommunicationSelectedCustomersList.vue';

export default {
  name: 'CommunicationManagerClientContent',
  components: {
    FormGroup,
    OnlySearchFilter,
    CommunicationCustomerFilter,
    InputSelect,
    CommunicationClientList,
    InputTextArea,
    CommunicationSelectedCustomersList,
    InputRadio,
  },
  mixins: [rulesMixin],
  computed: {
    payload() {
      return this.store.payload;
    },
    isAll() {
      return this.payload.todos;
    },
    isOption() {
      return o => this.option === o;
    },
    listIds: {
      get() {
        return this.payload.listaClientesIds.join(',');
      },
      set(value) {
        const items = String(value);
        this.payload.listaClientesIds = items.length > 1 ? items.split(',').filter(Boolean) : [items];
      },
    },
    isList() {
      return ['filtered', 'selected'].some(this.isOption);
    },
    options() {
      return this.store.sendedOptions;
    },
    option: {
      get() {
        return this.store.sendedOption;
      },
      set(value) {
        return this.store.setKeyData('sendedOption', value);
      },
    },
    elegivelOption: {
      get() {
        return this.store.elegivelOption;
      },
      set(value) {
        this.store.setKeyData('elegivelOption', value);
      },
    },
    store() {
      return this.communicationData;
    },
    selectedCustomers: {
      get() {
        return this.store.selectedCustomers;
      },
      setValue(value) {
        this.store.setKeyData('selectedCustomers', value);
      },
    },
  },
  inject: {
    communicationData: {
      default() {
        return {
          payload: {},
        };
      },
    },
  },
};
</script>
